import {db, uuid} from "../Database.svelte";
import {readable} from "svelte/store";

export default class KeyRecommendation {
    constructor (item_id) {
        this.item = db.get(item_id)
    }

    static getKeyRecommendationList() {
        let item_list = [];

        return readable(undefined, (set) => {
            db.allDocs({
                startkey: "keyRecommendation:",
                endkey: "keyRecommendation:\ufff0",
                include_docs: true,

            }).then((results) => {
                item_list = results.rows.map(r => r.doc);
                set(item_list)
            })

            let changeMonitor = db.changes({
                since: "now",
                live: true,
                include_docs: true,
                filter: "filters/doc_type",
                query_params: {
                    type: 'keyRecommendation'
                }
            }).on('change', (change) => {
                if (change.deleted) {
                    item_list = item_list.filter(rec => rec._id != change.id);
                } else {
                    let found = false;
                    item_list = item_list.map((rec) => {
                        if (rec._id != change.id) return rec;
                        found = true;
                        return change.doc;
                    });

                    if (!found) item_list.push(change.doc);
                }

                set(item_list)
            })

            return () => {
                changeMonitor.cancel();
            }
        })
    }

    static getKeyRecommendation(item_id) {
        return db.get(item_id);
    }

    static createKeyRecommendation(item) {
        item.item_id = uuid();
        item._id = `keyRecommendation:${item.item_id}`;
        item.type = 'keyRecommendation';

        return db.put(item);
    }

    static saveKeyRecommendation(item) {
        return db.put(item);
    }

    static deleteKeyRecommendation(item) {
        item._deleted = true;
        return db.put(item);
    }

    static async updateKeyRecommendation(item) {
        let recommendation = await this.getKeyRecommendation(item.template_id);

        recommendation.text = item.text;
        return this.saveKeyRecommendation(recommendation)
    }
}